import { render, staticRenderFns } from "./pages8.vue?vue&type=template&id=37cf2135&scoped=true&"
import script from "./pages8.vue?vue&type=script&lang=js&"
export * from "./pages8.vue?vue&type=script&lang=js&"
import style0 from "./pages8.vue?vue&type=style&index=0&id=37cf2135&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cf2135",
  null
  
)

export default component.exports